import { render, staticRenderFns } from "./ExaminationPaper.vue?vue&type=template&id=6da564b6&scoped=true"
import script from "./ExaminationPaper.vue?vue&type=script&lang=js"
export * from "./ExaminationPaper.vue?vue&type=script&lang=js"
import style0 from "./ExaminationPaper.vue?vue&type=style&index=0&id=6da564b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da564b6",
  null
  
)

export default component.exports